export const getBorderStyle = (startsSequence?: boolean, endsSequence?: boolean) => {
  const position = ['message', `${startsSequence ? 'start' : ''}`, `${endsSequence ? 'end' : ''}`].join(' ').trim()
  let borderStyle
  if (position === 'message start end') {
    borderStyle = 'tw-rounded-[20px]'
  }

  if (position === 'message start') {
    borderStyle = 'tw-rounded-tl-[20px] tw-rounded-br-[20px] tw-rounded-tr-[20px] tw-rounded-bl-[5px]'
  }

  if (position === 'message  end') {
    borderStyle = 'tw-rounded-tl-[5px] tw-rounded-br-[20px] tw-rounded-tr-[20px] tw-rounded-bl-[20px]'
  }
  if (position === 'message') {
    borderStyle = 'tw-rounded-tl-[5px] tw-rounded-bl-[5px] tw-rounded-br-[20px] tw-rounded-tr-[20px]'
  }

  return borderStyle
}
